function TermsOfService() {
  return (
    <>
      <title>Terms of Service - vidi3D</title>
      <meta name="robots" content="noindex" />
      <meta name="description" content="Read vidi3D's terms of service to understand your rights and responsibilities when using our virtual tour and 3D visualization services." />
      
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto p-8">
          <h1 className="text-6xl font-bold text-brand text-center py-12 mb-8">Terms of Service</h1>

          <div className="grid gap-8">
            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">1. Services Overview</h2>
              </div>
              <p className="text-brand-dark mb-4">vidi3D provides virtual tour and 3D visualization services. By accessing or using our services, you agree to be bound by these terms. Our services include:</p>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Creation of virtual tours and 3D visualizations
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Hosting and maintenance of virtual tours
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Customization and modification of virtual spaces
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Technical support related to our services
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">2. Intellectual Property Rights</h2>
              </div>
              <p className="text-brand-dark mb-4">All content, including but not limited to 3D tours, images, visualizations, software, code, and designs created by vidi3D remain our intellectual property unless explicitly stated otherwise in a written service agreement. Users are granted a limited, non-exclusive license to:</p>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  View and interact with the virtual tours
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Share links to the virtual tours
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Embed virtual tours on authorized websites
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">3. User Responsibilities and Conduct</h2>
              </div>
              <p className="text-brand-dark mb-4">Users of vidi3D services agree to:</p>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Provide accurate and complete information when using our services
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Use services for lawful purposes only
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Respect intellectual property rights
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Maintain the confidentiality of any account credentials
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Not attempt to reverse engineer or modify our services
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Not use our services to distribute malware or harmful code
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Not engage in activities that could damage or overload our systems
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">4. Payment and Refunds</h2>
              </div>
              <p className="text-brand-dark mb-4">Our payment and refund policies include:</p>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Payment is required before service delivery unless otherwise agreed
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  All prices are subject to change with notice
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Refunds are handled on a case-by-case basis
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Disputes must be raised within 30 days of service delivery
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">5. Limitation of Liability</h2>
              </div>
              <p className="text-brand-dark mb-4">vidi3D is not liable for any indirect, incidental, or consequential damages arising from:</p>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Use or inability to use our services
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Service interruptions or technical issues
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Loss of data or content
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Third-party claims
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">6. Modifications to Terms</h2>
              </div>
              <p className="text-brand-dark">vidi3D reserves the right to modify these terms at any time. Users will be notified of significant changes, and continued use of services constitutes acceptance of modified terms.</p>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">7. Contact Information</h2>
              </div>
              <p className="text-brand-dark mb-2">For questions about these terms, please contact us at:</p>
              <p className="text-brand-dark mb-2">Email: legal@vidi3d.com</p>
              <p className="text-brand-dark italic">Last updated: January 30, 2025</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default TermsOfService;